module.exports = __webpack_public_path__ + "static/media/klima-03.da0c8885.jpg";